<template>
  <div class="x-tablelist-view" data-automation="group">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @search="seach"
      @input="seach"
      @add="showAdd"
      @resetsearch="resetsearch"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
        :emptyText="$t('HT.nodata')"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import addGroup from './template/addGroup';
import domain from './template/domain';
import evnDomains from './template/evnDomains';
export default {
  components: {
    addGroup,
    domain,
    evnDomains
  },
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'input',
          key: 'name',
          placeholder: this.$t('HT.groupList.name.placeholder')
        },
        {
          type: 'button',
          text: this.$t('HT.reset'),
          plain: true,
          event: 'resetsearch'
        },
        {
          type: 'button',
          text: this.$t('HT.add'),
          icon: 'ux_icon_plus',
          right: true,
          hidden: !this.$hasModule(10),
          event: 'add'
        }
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.apiList.group'),
          tooltip: true,
          prop: 'name',
          align: 'left',
          render: (h, params) => {
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    this.$router.push({ name: 'groupInfo', query: { id: params.id } });
                  }
                }
              },
              params.name
            );
          }
        },
        {
          label: this.$t('HT.apiStepOne.remark'),
          prop: 'remark',
          align: 'left',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return cellValue || '--';
          }
        },
        {
          label: this.$t('HT.groupList.env'),
          tooltip: true,
          align: 'left',
          render: (h, params) => {
            return h(evnDomains, {
              props: {
                list: params.domains || []
              }
            });
          }
        },
        {
          label: this.$t('HT.createdTime'),
          prop: 'created_date',
          align: 'left',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(10),
          align: 'left',
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.groupInfo.bindDomain'), this.$t('HT.delete')],
                colors: ['#0087ff'],
                event: ['domain', 'del']
              },
              on: {
                domain: () => {
                  this.showDomain(params);
                },

                del: () => {
                  const title = this.$t('HT.groupList.del');
                  const content = this.$t('HT.groupList.del.content');
                  this.$uxModal.show({
                    title,
                    content,
                    confirm: () => {
                      this.delList(params.id);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        name: '', // 分组名称
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    this.getList(this.filter);
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.group.getList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },
    /**
     * 重置搜索项
    */
    resetsearch() {
      console.log('重置');
      this.filter.name = '';
      this.seach();
    },
    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     */
    addList(params) {
      this.$uxLoading.show();
      this.$api.group.addList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(id) {
      this.$uxLoading.show();
      this.$api.group.delList(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          if (this.tableData.list.length === 1) {
            this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
          }
          this.getList(this.filter);
        }
      });
    },

    /**
     * 域名绑定
     * @param {Object} params 表单提交参数
     */
    domain(params) {
      this.$uxLoading.show();
      this.$api.group.domain(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.bindSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 新建分组弹窗
     */
    showAdd() {
      const title = this.$t('HT.groupList.add');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addGroup);
        },
        confirm: (params) => {
          this.addList(params);
        }
      });
    },

    /**
     * 绑定域名弹窗
     * @param {Object} params 单行表格数据
     */
    showDomain(params) {
      const title = this.$t('HT.groupInfo.bindDomain');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(domain, {
            props: { data: params },
            on: {}
          });
        },
        confirm: (params) => {
          this.domain(params);
        }
      });
    },

    /**
     * 点击搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
